module.exports = __webpack_public_path__ + "img/entrepreneur.4386b89c.webp";